import React from 'react'
import {translate, Trans} from 'react-i18next'
import {withTheme} from 'styled-components'

import {withNotifications} from 'hocs'
import {compose} from 'utils/reactUtils'
// import {getChangePasswordErrorMessage} from 'utils/errorUtils'
import View from 'components/View'
import Note from 'components/Note'
import Bold from 'components/Bold'
// import {NOTIFICATION_TYPES} from 'const/notifications'
import {GoogleAnalyticsService, HostedLoginService} from 'services'
import {StyledTitle} from './styles'
import ResetPasswordLink from '../../../consent-app/email-reset-password-sent/components/ResetPasswordLink'
import PageMessage from 'components/PageMessage'

const SecurityPasswordReset = ({email, loginCase = 'default', /* showNotification, */ t, theme}) => {
  const resendPassword = async () => {
    try {
      await HostedLoginService.resendSecurityResetPasswordEmail({email, brand: theme.brand.name, loginCase})
      GoogleAnalyticsService.trackChangePassword()

      // showNotification(NOTIFICATION_TYPES.success, 'success')
    } catch (error) {
      // const message = getChangePasswordErrorMessage(error)
      // showNotification(NOTIFICATION_TYPES.error, message)
    }
  }

  return (
    <View>
      <StyledTitle>{t('security-reset-password.title', {fallbackLng: 'en'})}</StyledTitle>
      <PageMessage info>
        <Note light>
          <Trans i18nKey="security-reset-password.info-email">
            text
            <Bold regular>{email}</Bold>
            text
          </Trans>
        </Note>
        <Note light>{t('security-reset-password.info-spam', {fallbackLng: 'en'})}</Note>
      </PageMessage>
      <Note marginTop="48px">{t('security-reset-password.reason-title', {fallbackLng: 'en'})}</Note>
      <Note light>{t('security-reset-password.reason-message', {fallbackLng: 'en'})}</Note>
      <ResetPasswordLink onClick={resendPassword} />
    </View>
  )
}

export default compose(translate(), withNotifications(), withTheme)(SecurityPasswordReset)
